var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ShowSeriennummerWrapper"},[_vm._v(" "+_vm._s(_vm.$t("message.show_seriennummer_seriennummer"))+": "+_vm._s(_vm.seriennr)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }